class ATMCountPrintController {
    /*@ngInject*/
    constructor($translate) {
        this.$translate = $translate;
    }

    $onInit() {
        if (window.opener && window.opener.w && window.opener.w.printData && window.opener.w.printData.doPrint) {
            this.pendingATMResidualCount = window.opener.w.printData.pendingATMResiduals;
            this.routeId = window.opener.w.printData.route;
            this.branchId = window.opener.w.printData.branchId;
            this.fundingSource = window.opener.w.printData.fundingSource;
            this.amount = window.opener.w.printData.amount;
            setTimeout(() => {
                window.print();
            }, 1000)
        }
    }

    getOrderType(shiptype, type) {
        if (shiptype == "C" && type !== null) {
            return this.$translate.instant('atm_residual.order_type_' + type);
        }
        else if (shiptype == "C" && type == null) {
            return shiptype.toUpperCase();
        }
        else {
            return shiptype.toUpperCase();
        }
    }
}

export default ATMCountPrintController;


// WEBPACK FOOTER //
// ./client/app/components/atm_count/print/atm_count_print.controller.js